import hoist from 'hoist-non-react-statics';
import React, { PureComponent } from 'react';
import { getDisplayName } from '@zocdoc-frontend-common/utils-react';

export default function (WrappedComponent) {
    class WithInsuranceValidation extends PureComponent {
        static displayName = `WithInsuranceValidation(${getDisplayName(
            WrappedComponent
        )})`;
        static WrappedComponent = WrappedComponent;

        componentDidUpdate(prevProps) {
            if (
                prevProps.insuranceIsAccepted !==
                    this.props.insuranceIsAccepted &&
                this.props.insuranceIsAccepted !== undefined
            ) {
                this.props.triggerInsuranceValidationChanged(
                    this.props.insuranceIsAccepted
                );
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    hoist(WithInsuranceValidation, WrappedComponent);

    return WithInsuranceValidation;
}
